// extracted by mini-css-extract-plugin
module.exports = {"ChoosePaymentMethod":"ChoosePaymentMethod_ChoosePaymentMethod__40i0H"};